const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_MASTER_URL = process.env.REACT_APP_API_MASTERS_URL;
const BASE_SCREEN_BUILDER_URL = process.env.REACT_APP_API_ScreenBuilder_URL;
const BASE_LEAD_SERVICE_URL = process.env.REACT_APP_API_LEAD_SERVICE_URL;
const AUDIT_URL = process.env.REACT_APP_API_AUDIT_URL;
const BASE_AI_QUEST_DOC_URL = process.env.REACT_APP_AI_QUEST_DOC_API_URL;

export const API_CONFIG = {
  BASE_URL,
  AUDIT_URL,
  TIMEOUT: 120000, // 2 minutes for bulk operations
  HEADERS: {
    "Content-Type": "application/json",
  },
};

export const API_MASTER_CONFIG = {
  BASE_MASTER_URL,
  TIMEOUT: 30000,
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

export const API_SCREEN_BUILDER_CONFIG = {
  BASE_SCREEN_BUILDER_URL,
  TIMEOUT: 30000,
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

export const API_LEAD_SERVICE_CONFIG = {
  BASE_LEAD_SERVICE_URL,
  TIMEOUT: 60000,
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

export const API_AI_QUEST_DOC_CONFIG = {
  BASE_AI_QUEST_DOC_URL,
  TIMEOUT: 120000,
  HEADERS: {
    'Content-Type': 'application/json',
  },
};
export const API_master_ENDPOINTS = {
  MASTERS: {
    LIST: '/v1/master-state',
    DETAIL: '/masters',
    CREATE: '/masters',
    UPDATE: '/masters',
    DELETE: '/masters',
    SEARCH: '/masters/search',
    BULK_UPLOAD: 'v1/excel/uploadExcel',
    BULK_UPLOAD_PINCODE: 'v1/excel/uploadPincodeExcel',
    BULK_UPDATE_CHILD: 'v1/excel/updateChildMaster',
    BULK_UPLOAD_TSE_BDR: 'v1/excel/uploadTseBdrExcel',
    BULK_UPLOAD_HDFC_BRANCH_LOCATION: 'v1/excel/uploadHdfcBranchLocation',
    BULK_UPLOAD_HDFC_BRANCH_SUB_LOCATION: 'v1/excel/uploadHdfcBranchSubLocation',
    // DYNAMIC_PARENT: '/v1/dynamic-parent/getAllDynamicParents',
    DYNAMIC_PARENT: '/v1/main-master/getAllMasters',
    UPDATE_DYNAMIC_PARENT: '/v1/dynamic-parent/updateDynamicParent',
    DYNAMIC_CHILD: '/v1/dynamic-child/getDynamicChildren',
    PATCH_DYNAMIC_CHILD: '/v1/dynamic-child/UpdateDynamicChild',
    TSE_BDR: '/v1/static-master/getAllTseBdrMaster',
    PINCODE: '/v1/static-master/getAllPincodeMaster',
    HDFC_BRANCH_LOCATION: '/v1/static-master/getAllHdfcBranchLocationMaster',
    HDFC_BRANCH_SUB_LOCATION: '/v1/static-master/getAllHdfcSubBranchLocations',
    ERGO_SM_CODE: '/v1/static-master/getAllErgoSmCode',
    SUB_CHANNEL: '/v1/static-master/getAllSubChannel',
    FETCH_CHANNEL_NAME: '/v1/master-apis/fetchDynamicMasterRecords',
    FETCH_BRANCH_LOCATION: '/v1/master-apis/fetchDynamicMasterRecords',
  },
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/v1/auth/login",
    GET_USER_TYPE: "/v1/auth/get-user-type",
    LOGOUT: "/v1/auth/logout",
    REFRESH: "/v1/auth/refresh",
    OTP_INITIATE: "v1/auth/password-reset/initiate",
    RESET_PASSWORD: "v1/auth/password-reset/setPassword",
    VERIFY_OTP: "v1/auth/password-reset/verifyOtp",
    CHANGE_PASSWORD: "v1/auth/change-password",
    RESEND_OTP: "v1/auth/password-reset/resend-otp",
  },
  USERS: {
    LIST: "v1/users",
    DETAIL: "v1/users",
    CREATE: "v1/users",
    UPDATE: "v1/users",
    DELETE: "v1/users",
    BULK_UPLOAD: "/users/bulk-upload",
    ROLES: (userId) => `v1/users/roles?userId=${userId}`,
    USER_SEARCH: "v1/users/profile/usersearch",
    PASSWORD_RESET: "v1/users/{userId}/reset-password",
    EFFECTIVE_PERMISSIONS: (userId) => `v1/users/${userId}/effective-permissions`,
    ACTIVATE: (userId) => `v1/users/${userId}/activate`,
    DEACTIVATE: (userId) => `v1/users/${userId}/deactivate`,
    CHECK_AVAILABILITY: "v1/users/check-availability",
  },
  ROLES: {
    LIST: "v1/role",
    DETAIL: "v1/roles",
    CREATE: "v1/role",
    UPDATE: "v1/role",
    DELETE: "v1/role",
    PERMISSIONS: "v1/role",
    ACTIVATE: (roleId) => `v1/role/${roleId}/activate`,
    DEACTIVATE: (roleId) => `v1/role/${roleId}/deactivate`,
  },
  ROLE: {
    MENUS: "/v1/role/menus",
    PERMISSIONS: "/v1/role/permissions",
    USER_TYPES: "/v1/role/user-types",
  },
  LEAD: {
    STATISTICS: "/v1/leads/statistics/summary",
  },
  PERMISSIONS: {
    LIST: "/permissions",
    DETAIL: "/permissions",
    CREATE: "/permissions",
    UPDATE: "/permissions",
    DELETE: "/permissions",
  },
  // MASTERS: {
  //   LIST: "/masters",
  //   DETAIL: "/masters",
  //   CREATE: "/masters",
  //   UPDATE: "/masters",
  //   DELETE: "/masters",
  //   SEARCH: "/masters/search",
  //   BULK_UPLOAD: "/masters/bulk-upload",
  // },
  AUDIT: {
    LIST: "/audit",
    DETAIL: "/audit",
    EXPORT: "/audit/export",
    ACTION_TYPES: "v1/audit/action-types",

  },
  MENU: {
    CONFIGURATION: "/v1/menu/configuration",
    USER_PERMISSIONS: "/v1/menu/user-permissions",
  },

  AUDIT_SEARCH: {
    AUDIT_SEARCH: "v1/audit-trail/search",
  },

  NOTIFICATIONS: {
    LIST: "/v1/notifications",
    DETAIL: "/v1/notifications",
    CREATE: "/v1/notifications",
    UPDATE: "/v1/notifications",
    DELETE: "/v1/notifications",
    TYPES: "/v1/notifications/types/list",
    ACTIVE_BY_ROLE: (roleId) => `/v1/notifications/active/role/${roleId}`,
    ACTIVATE: (notificationId) => `/v1/notifications/${notificationId}/activate`,
    DEACTIVATE: (notificationId) => `/v1/notifications/${notificationId}/deactivate`,
    UPLOAD_DOCUMENT_TEMP: "/v1/notifications/upload-document-temp",
    ACTION_TYPES: "v1/audit/action-types?moduleType=NOTIFICATION_MANAGEMENT",
  },

  NOTIFICATION_AUDIT: {
    SEARCH: "v1/notification-audit/search",
    DETAILS: "v1/notification-audit/details",
    BY_NOTIFICATION: "v1/notification-audit/notification",
    EVENT_TYPES: "v1/notification-audit/event-types",
    EXPORT: "v1/notification-audit/export",
    DOWNLOAD: "v1/notification-audit/download",
    STATISTICS: "v1/notification-audit/statistics",
  },
};
